/* eslint-disable import/prefer-default-export */
import { schema } from 'normalizr';

const eventsListSchema = [new schema.Entity('events')];

export {
  eventsListSchema,
};
